import Container from '../../Container';
import { Copyright } from '../Copyright';
import { Legal } from '../Legal';

import styles from './styles.module.scss';

export const Minimal = ({
  theme,
  legalMenu,
  copyrightStartYear,
  companyLegalName,
}) => (
  <footer role="contentinfo">
    <Container className={styles.container}>
      <Copyright
        copyrightStartYear={copyrightStartYear}
        companyLegalName={companyLegalName}
      />
      <Legal legalMenu={legalMenu} theme={theme} />
    </Container>
  </footer>
);
